import "react-loading-skeleton/dist/skeleton.css";

import { usePatientConsents } from "@/api2/Consent/queries/usePatientConsents";
import type { Profile } from "@/core/types";
import type { UUID } from "@/core/types";

import { MemberProfileACPSection } from "../MemberProfileACPSection/MemberProfileACPSection";
import MemberProfileConsentList from "../MemberProfileConsentList";
import MemberProfilePolicyList from "../MemberProfilePolicyList";

import { MemberProfileConsentsSectionSkeleton } from "./MemberProfileConsentsSectionSkeleton";
import { isAdult } from "@/utils/profileUtilsTyped";

type MemberProfileConsentsSectionProps = {
  insuranceCarrier: string;
  dob?: Profile["dob"];
  patientId: UUID;
};

export function MemberProfileConsentsSection({
  insuranceCarrier,
  dob,
  patientId,
}: MemberProfileConsentsSectionProps) {
  const { data: consents, isLoading } = usePatientConsents(patientId);
  const isPatientAdult = isAdult(dob);

  if (isLoading || !consents) return <MemberProfileConsentsSectionSkeleton />;

  return (
    <>
      {isPatientAdult && (
        <MemberProfileACPSection consents={consents} insuranceCarrier={insuranceCarrier} />
      )}
      <MemberProfilePolicyList consents={consents} patientId={patientId} />
      <MemberProfileConsentList consents={consents} patientId={patientId} />
    </>
  );
}
